import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { EmployeeChatComponent } from 'src/app/shared/components/employee-chat/employee-chat.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { YoutubeEmbedVideoComponent } from '../new-v2-component/youtube-embed-video/youtube-embed-video.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SelectBusinessCountryComponent } from 'src/app/shared/components/select-business-country/select-business-country.component';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';

@Component({
  selector: 'sm-new-employees',
  templateUrl: './new-employees.component.html',
  styleUrls: ['./new-employees.component.scss']
})
export class NewEmployeesComponent implements OnInit, OnDestroy {
  selectedBusiness: any;
    panelState: any = [true, false, false, false, false];
  
  businessListData: any = [];
  employeeData: any = [];
  loader: boolean = false;
  apisub: Subscription;
  foundEmployee:any = {
    name: '',
    img: '',
    employeeHash: ''
  }
  hidediv: boolean = false
  isEmployeeAndHasBusinessButDoesNotHaveAccess:boolean = false
  constructor(private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private loaderservice: LoaderServiceService,
    private apiservice: ApiService,
    private dialog:MatDialog,
    private route: ActivatedRoute) { 
      this.navservice.hideSidebarAndNav=false
      
      this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
        if (
          resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
        ) {
          this.businessListData = [];
          if (resdata.result) {
            this.businessListData = resdata.result;
            let checkForAccessLength = this.businessListData.length
            this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0 // Add the isSelected property
            }))
            .filter((element: any) => 
              (element.is_owner == 1 && element.entitySubscriptionInfo && 
                element.entitySubscriptionInfo !== 'null')
            );
            if(checkForAccessLength - this.businessListData.length > 0){
              this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true
            }  
            if(this.businessListData.length > 0){
              this.businessListData[0].isSelected = 1;
              this.selectedBusiness = this.businessListData[0];
              localStorage.setItem(
                SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
                this.selectedBusiness.entity_public_hash_id
              );
              localStorage.setItem(
                SM_CONSTANTS.CURRENT_ENTITY_NAME,
                this.selectedBusiness.name
              );
              localStorage.setItem(
                SM_CONSTANTS.CURRENT_ENTITY_ADDRESS,
                this.selectedBusiness.address_line
              );
              localStorage.setItem(
                SM_CONSTANTS.CURRENT_ENTITY_HASH,
                this.selectedBusiness.hash_id
              );
              localStorage.setItem(
                SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
                this.selectedBusiness.employee_hash_id
              );
              let countryList: any[] = COUNTRY_CODES;
  
              let selectedCurrency = {
                currency: this.selectedBusiness.currency,
                currencySymbol: this.selectedBusiness.currency_symbol,
                countryCode: this.selectedBusiness.entity_country_code,
                code: countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code && country.currency === this.selectedBusiness.currency)?.code
              };
              sessionStorage.setItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,JSON.stringify(selectedCurrency))

            }
          }
          if (this.businessListData.length > 0) {
            this.apiservice.getEmployeeList(this.selectedBusiness.hash_id)
          } else {
            this.loaderservice.showLoader = false;
            this.loader = false;
          }
        }
        if(resdata.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT){
          console.log(resdata);
          this.employeeData = []
          if(resdata.result){
            resdata.result.forEach((element:any) => {
              if(element.isExEmployee == 0){
                if(element.is_owner == 0){
                  if(element.addressInfo && element.addressInfo!= null && element.addressInfo!= 'null'){
                    element.addline = typeof element.addressInfo == 'string' ?  (JSON.parse(element.addressInfo)).addressLine : element.addressInfo.addressLine
                      }
                      if(element.assigned_slots){
              element.assigned_slots = typeof element.assigned_slots == 'string' ? JSON.parse(element.assigned_slots) : element.assigned_slots
              element.formatted_assigned_slots = this.getUniqueTimeRangesWithCount(element.assigned_slots)
            }
                  this.employeeData.push(element)
                }
              }
            });
          }
          this.loaderservice.showLoader = false;
          this.loader = false;
          this.hidediv = false
          if(sessionStorage.getItem('toShowAlert')){
            let data = typeof sessionStorage.getItem('toShowAlert') == 'string' ? JSON.parse(sessionStorage.getItem('toShowAlert')!) : sessionStorage.getItem('toShowAlert')
           
            const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
              width: '500px',
              data : {
                title : 'Invitation successful!',
                message : 'The invitation sent successfully to ' + data.employeeName + ' to join ' +  data.businessname + '. ' + data.employeeName + ' can see this joining invitation on the LookzUp Business app.',
                cancelbtn : 'Ok',
                okbtn : 'Go to Invitations',
                type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
              },
              disableClose : true
            });
            dialogRef.afterClosed().subscribe(result=>{
              console.log(result);
              sessionStorage.removeItem('toShowAlert')
              if(result){ 
                sessionStorage.setItem('toShowInvitation', '1')
                this.router.navigate(['/businesses', 'details','employees'],{queryParams: {entityHash: data.businesshash}})
              }
            })
          }
          
        }
        if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID_FOR_EMPLOYEE){
          // this.chatThreads = []
          if(resdata.result){
  
            resdata.result.forEach((element:any) => {
              if(element.senderInfo && element.receiverInfo){
                if(element.senderInfo && typeof element.senderInfo == 'string'){
                  element.senderInfo = JSON.parse(element.senderInfo)
                }
                if(element.receiverInfo && typeof element.receiverInfo == 'string'){
                  element.receiverInfo = JSON.parse(element.receiverInfo)
                }
                console.log(this.senderHashId);
                console.log(this.receiverHashId);
                
               if( (element.senderInfo.hash_id == this.senderHashId && element.receiverInfo.hash_id == this.receiverHashId && element.entity_public_hash_id == localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)) || (element.senderInfo.hash_id== this.receiverHashId && element.receiverInfo.hash_id == this.senderHashId && element.entity_public_hash_id == localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID))){
                this.previousChatHash = element.hash_id
               }
              
              }
            });
            console.log(this.previousChatHash);
            
          }
          this.loaderservice.showLoader = false
          this._modelRef.open(EmployeeChatComponent, {
            width: "500px",
            panelClass: 'custom-dialog-container',
            data: {
            title: this.foundEmployee.name,
            ref: this._modelRef,
            previousChatHash: this.previousChatHash,
            employeeImage: this.foundEmployee.img,
            employeeHash: this.receiverHashId
            },
          });
        }
      })
    
    }

  ngOnInit(): void {
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }

  
  createNewBusiness(){
    this.router.navigate(['purchased-plan'])
  }
  newemployeedetails(employee:any){
    this.router.navigate(['employee-details'],{relativeTo: this.route, queryParams: {
      employeeHash: employee.employeeHashId,
      entityHash: this.selectedBusiness.hash_id
    }})

  }

  selectBusiness(index: any) {
  
    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      this.selectedBusiness.entity_public_hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_HASH,
      this.selectedBusiness.hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_NAME,
      this.selectedBusiness.name
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_ADDRESS,
      this.selectedBusiness.address_line
    );
    localStorage.setItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
            this.selectedBusiness.employee_hash_id
          );

          let countryList: any[] = COUNTRY_CODES;

          let selectedCurrency = {
            currency: this.selectedBusiness.currency,
            currencySymbol: this.selectedBusiness.currency_symbol,
            countryCode: this.selectedBusiness.entity_country_code,
            code: countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code && country.currency === this.selectedBusiness.currency)?.code
          };
          sessionStorage.setItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,JSON.stringify(selectedCurrency))
    this.loaderservice.showLoader = true
    this.hidediv = true
    this.apiservice.getEmployeeList(this.selectedBusiness.hash_id)
  
  }

  employeeplan(){
    sessionStorage.setItem(SM_CONSTANTS.CURRENT_ROUTE_FOR_NEW_EMPLOYEE, '1')
    this.router.navigate(['purchased-plan'],{relativeTo: this.route})
  }
  senderHashId:any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)
  receiverHashId:any
  previousChatHash:any
  openMessages(item:any,event:Event){
    event.stopPropagation();
    this.loaderservice.showLoader = true
    this.receiverHashId = item.profileHashId
    this.foundEmployee.name = item.name
    this.foundEmployee.img = item.imgThumbUrl
    this.foundEmployee.employeeHash = item.employeeHashId
    this.apiservice.getMessagesByIDForEmployee()
    
  }
ngOnDestroy(): void {
  this.apisub.unsubscribe()
}  

openvideo(){
  this.dialog.open(YoutubeEmbedVideoComponent,{
  width:'1000px',
  disableClose:true,
  data:{
    link:"https://www.youtube.com/embed/_gn1Jq1OeGM?si=OLs3C2p0ZESpz-uq",
    title: 'Adding Employees & Co-Workers in LookzUp Business Platform. '
  }})
  }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }

  selectcountry(){
    let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
    width:'500px',
    disableClose:true,
    data:{
      link:"",
      title: 'Select business country',
      ref: this.dialog
    }})
    dialogref.afterClosed().subscribe(res => {
      if(res){
        this.router.navigate(['purchased-plan']);
      }
    } 
    )
    }
    openLink(url: string): void {
      window.open(url, '_blank');
    }
getUniqueTimeRangesWithCount(timeRanges: any[]): any[] {
  const map = new Map<string, any>();

  for (const range of timeRanges) {
    const key = `${range.start_time}|${range.end_time}`;
    if (map.has(key)) {
      map.get(key).count += 1;
    } else {
      map.set(key, {
        start_time: range.start_time,
        end_time: range.end_time,
        count: 1
      });
    }
  }

  return Array.from(map.values());
}
}

